export const ORGANIZATION_NAME_INPUT_TEST_ID = 'organization-name'
